import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home.vue";
import Press from "../components/Press.vue";
import Valve from "../components/Valve"
import Home_v1 from "../components/contract/Home_v1.vue";
import Press_v1 from "../components/contract/Press_v1.vue";
import Valve_v1 from "../components/contract/Valve_v1.vue";
import Home_virtual from "../components/virtual/Home_virtual.vue";
import Press_virtual from "../components/virtual/Press_virtual.vue";
import Valve_virtual from "../components/virtual/Valve_virtual.vue";
import electircity from "../components/electricity/index.vue"
import As_Device from "../components/asdevice/index.vue"
import valve_control from "../components/valveControl.vue"
import noise from "../components/noise/index.vue"


Vue.use(Router)

const axios = require('axios').default;
axios.defaults.baseURL = 'https://gzdx.chuangyibaoneng.com/'
// axios.defaults.baseURL = 'http://127.0.0.1:8081'

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/press',
      name: 'Press',
      component: Press
    },
    {
      path: '/Valve',
      name: 'Valve',
      component: Valve
    },
    // v1 版本为84端口的720服务
    {
      path: '/v1',
      name: 'Home_v1',
      component: Home_v1
    },
    {
      path: '/v1/press',
      name: 'Press_v1',
      component: Press_v1
    },
    {
      path: '/v1/Valve',
      name: 'Valve_v1',
      component: Valve_v1
    },
    // v3 版本为虚拟系统端口的720服务
    {
      path: '/v3',
      name: 'Home_virtual',
      component: Home_virtual
    },
    {
      path: '/v3/press',
      name: 'Press_virtual',
      component: Press_virtual
    },
    {
      path: '/v3/Valve',
      name: 'Valve_virtual',
      component: Valve_virtual
    },
    {
      path: '/electricity/index',
      name: 'electricity',
      component: electircity
    },
    {
      path: '/asdevice',
      name: 'asdevice',
      component: As_Device
    },
    {
      path: '/valve_control',
      name: 'valve_control',
      component: valve_control
    },
    {
      path: '/noise',
      name: 'noise',
      component: noise
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js